export default __webpack_public_path__ + "static/media/MediaData.da01151a.svg";